import { render, staticRenderFns } from "./DebugEvents.vue?vue&type=template&id=680c1a48&scoped=true&"
import script from "./DebugEvents.vue?vue&type=script&lang=js&"
export * from "./DebugEvents.vue?vue&type=script&lang=js&"
import style0 from "./DebugEvents.vue?vue&type=style&index=0&id=680c1a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c1a48",
  null
  
)

export default component.exports